import { AxiosPromise, CancelToken } from 'axios';
import { EmailSettings } from '../sic-lib/types/EmailSettings';
import { TimeZoneSettings } from '../sic-lib/types/GeneralSettings';
import { UpdateParameterRequest } from '../sic-lib/types/Settings';
import { apiInstance as instance } from './';

/**
 * Makes a HTTP request for the client's settings
 * @param data
 */
export function requestGeneralSettings(
    data: {},
    cancelToken: CancelToken,
): AxiosPromise<[TimeZoneSettings]> {
    return instance.post('/config/parameters', data, {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function requestUpdateSettings(
    data: UpdateParameterRequest[],
    cancelToken: CancelToken,
): AxiosPromise<boolean> {
    return instance.put('/config/parameters', data, {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function requestUserEmailSettings(cancelToken: CancelToken): AxiosPromise<EmailSettings> {
    return instance.get('/config/parameters/email', {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function requestAssignEmailSettings(
    settings: EmailSettings,
    cancelToken: CancelToken,
): AxiosPromise<unknown> {
    return instance.put('/config/parameters/email', settings, {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function RequestTestUserEmailSettings(
    settings: EmailSettings,
    cancelToken: CancelToken,
): AxiosPromise<unknown> {
    return instance.post('/config/parameters/email/test', settings, {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function RequestDeleteUserEmailSettings(cancelToken: CancelToken): AxiosPromise<unknown> {
    return instance.delete('/config/parameters/email', {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function RequestInitalizeGoogleCalendar(cancelToken: CancelToken): AxiosPromise<unknown> {
    return instance.post('/config/InitalizeGoogleCalendar', null, {
        cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
